import React from 'react';
import PaginaInfoPage from './PaginaInfoPage';

/** /de-excel-a-app: pasar la planilla a la app (contenido en src/content/paginasInfo.ts). */
const DeExcelAAppPage: React.FC = () => <PaginaInfoPage pagina="deExcelAApp" />;

export default DeExcelAAppPage;
